// Weather-inferred risk confidence decays with forecast horizon.
// Right at MISO's day-ahead cutoff (~day 6), the weather model is most useful
// and most trustworthy. 14+ days out, forecasts swing wildly and should be
// weighted accordingly.

export function weatherConfidence(daysAhead) {
  if (daysAhead <= 6)  return 1.00;
  if (daysAhead <= 7)  return 0.95;
  if (daysAhead <= 8)  return 0.88;
  if (daysAhead <= 9)  return 0.80;
  if (daysAhead <= 10) return 0.72;
  if (daysAhead <= 11) return 0.65;
  if (daysAhead <= 12) return 0.58;
  if (daysAhead <= 13) return 0.52;
  return 0.45;
}

export function daysBetween(todayISO, futureISO) {
  const a = new Date(todayISO + 'T00:00:00');
  const b = new Date(futureISO + 'T00:00:00');
  return Math.round((b - a) / 86400000);
}
